@for (item of navItems(); track item) {
    @switch (helper.itemType(item)) {
        @case ('group') {
            <sq-sidebar-nav-group
                #rla="routerLinkActive"
                [dropdownMode]="dropdownMode"
                [item]="item"
                [ngClass]="item | sidebarNavItemClass"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLinkActive="show"
                [compact]="compact"></sq-sidebar-nav-group>
        }
        @case ('divider') {
            <sq-sidebar-nav-divider
                [sqHtmlAttributes]="item.attributes ?? {}"
                [item]="item"
                [ngClass]="item | sidebarNavItemClass" />
        }
        @case ('title') {
            <sq-sidebar-nav-title [item]="item" [ngClass]="item | sidebarNavItemClass"></sq-sidebar-nav-title>
        }
        @case ('label') {
            <sq-sidebar-nav-label [item]="item" [ngClass]="item | sidebarNavItemClass" />
        }
        @case ('empty') {
            <ng-container />
        }
        @default {
            <sq-sidebar-nav-link [item]="item" [ngClass]="item | sidebarNavItemClass" />
        }
    }
}
<ng-content />
